// React
import React, { useEffect, useState } from 'react';
// Material-UI
import { Button, CircularProgress } from '@material-ui/core';
// Otras libs

// Componentes

// Funciones

// Hooks


/**
 * Especifica la función a ser ejecutada al hacer click en el botón
 * @callback OnClick
 * @param {React.MouseEventHandler<HTMLButtonElement>} event Evento de botón
 * @returns {Promise<bool>}
 */

/**
 * Especifica la función a ser ejecutada al finalizar operación de promesa
 * @callback OnFinish
 * @param {bool} state Estado exitoso de operación
 * @returns {void}
 */

/**
 *
 * @typedef {Object} Props
 * @property {string} label Etiqueta de botón
 * @property {'default' | 'primary' | 'secondary'} [color] Color de botón
 * @property {OnClick} onClick Evento al presionar botón
 * @property {OnFinish} onFinish Evento al finalizar ejecución de promise
 */

/**
 * Botón de carga
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns
 */
export const BotonCarga = ({ 
    label = '',
    color = 'primary',
    onClick = (event) => {},
    onFinish = (e) => {},
}) => {
    // Idioma

    // Estados
    const [isLoading, setIsLoading] = useState(false);
    const [resOp, setResOp] = useState(null);

    useEffect(() => {
        if (resOp !== null) {
            onFinish(resOp);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resOp])

    // Vista
    return (
        <Button
            variant="contained"
            color={color}
            disableElevation
            size="small"
            disabled={isLoading}
            onClick={async (o) => {
                setIsLoading(true);
                setResOp(null);
                const res = await onClick(o);
                setResOp(res);
                setIsLoading(false);
            }}
        >
            {isLoading && (
                <CircularProgress size={20} style={{ marginRight: 5 }} />
            )}
            {label}
        </Button>
    );
};
